// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import { ReactNode } from 'react';
import styled from '@emotion/styled';
import {
  spacing,
  fontSize,
  fontWeight,
  borderRadius,
} from 'presentations/views/styles';
import { black, blueGrayPale } from 'presentations/views/styles/color';
import Icon from 'presentations/views/components/atoms/Icon';
import Link from 'presentations/views/components/atoms/Link';
import { isInElectron } from 'presentations/views/helpers/electron';
import { pricingPath } from 'presentations/routes/path';
import { PlanId } from 'domains/models/subscription/planId';

interface Props {
  className?: string;
  description?: string | ReactNode | null;
  plan?: PlanId;
  link?: string;
  label?: string;
}

export default function Component(props: Props) {
  const isElectron = isInElectron();
  if (isElectron) return null;
  const t = translateInComponent(translations);
  let label;
  switch (props.plan) {
    case PlanId.Pro:
      label = t('UpgradePro');
      break;
    case PlanId.Team:
      label = t('UpgradeTeam');
      break;
    case PlanId.Enterprice:
      label = t('UpgradeEnterprise');
      break;
    default:
      label = t('Upgrade');
      break;
  }

  return (
    <Container>
      {props.description && <Description>{props.description}</Description>}
      <Paid href={props.link || pricingPath()} target="_blank">
        <PaidArrowIcon name="chevron-right" color="primary" />
        <PaidLabel>{props.label || label}</PaidLabel>
      </Paid>
    </Container>
  );
}

export const Container = styled.div`
  background-color: ${blueGrayPale};
  padding: ${spacing(16)};
  border-radius: ${borderRadius(12)};
  font-size: ${fontSize(12)};
`;
export const Description = styled.div`
  color: ${black};
`;
export const PaidLabel = styled.span`
  font-size: ${fontSize(12)};
`;
export const PaidArrowIcon = styled(Icon)`
  width: 14px !important;
  height: 14px !important;
`;
export const Paid = styled(Link)`
  display: flex;
  align-items: center;
  margin-top: ${spacing(16)};
  font-weight: ${fontWeight('bold')};
`;
